import React from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

const FormElement = styled.div`
  width: 200px;
`;

export const GrownupsHurdleBody: React.FC<{
  day: string;
  setDay: (x: string) => void;
  month: string;
  setMonth: (x: string) => void;
  year: string;
  setYear: (x: string) => void;
}> = ({ day, setDay, month, setMonth, year, setYear }) => {
  const { t } = useTranslation();
  return (
    <div className="d-flex gap-3 flex-wrap justify-content-center">
      <FormElement className="form-floating">
        <select
          id="monthPicker"
          className="form-select required"
          onChange={(e) => setMonth(e.target.value)}
          defaultValue=""
        >
          <option disabled value="">
            {t("verify_age_select_a_month")}
          </option>
          <option value={0}>{t("verify_age_january")}</option>
          <option value={1}>{t("verify_age_february")}</option>
          <option value={2}>{t("verify_age_march")}</option>
          <option value={3}>{t("verify_age_april")}</option>
          <option value={4}>{t("verify_age_may")}</option>
          <option value={5}>{t("verify_age_june")}</option>
          <option value={6}>{t("verify_age_july")}</option>
          <option value={7}>{t("verify_age_august")}</option>
          <option value={8}>{t("verify_age_september")}</option>
          <option value={9}>{t("verify_age_october")}</option>
          <option value={10}>{t("verify_age_november")}</option>
          <option value={11}>{t("verify_age_december")}</option>
        </select>
        <label
          id="monthPicker-label"
          htmlFor="monthPicker"
          className="form-label"
        >
          {t("verify_age_month")}
        </label>
      </FormElement>
      <FormElement className="form-floating">
        <input
          type="number"
          className="form-control"
          id="datePicker"
          placeholder=""
          onChange={(e) => setDay(e.target.value)}
        />
        <label
          className="text-muted"
          id="datePicker-label"
          htmlFor="datePicker"
        >
          {t("verify_age_day")}
        </label>
      </FormElement>
      <FormElement className="form-floating">
        <input
          type="number"
          className="form-control"
          id="yearPicker"
          placeholder=""
          onChange={(e) => setYear(e.target.value)}
        />
        <label
          className="text-muted"
          id="yearPicker-label"
          htmlFor="yearPicker"
        >
          {t("verify_age_year")}
        </label>
      </FormElement>
    </div>
  );
};
